import { cloneDeep } from 'lodash';

export const getTiersError = (key, index, innerIndex, tiers, value, tierErrors) => {
  const clonedTires = cloneDeep(tiers);
  const activeLineError = checkActiveLine(key, index, innerIndex, clonedTires, value, tierErrors);
  const inactiveLinesOnSameTierError = checkInActiveLinesOnSameTier(
    key,
    index,
    innerIndex,
    clonedTires,
    value,
    activeLineError,
  );
  const sameLineOnInactiveTiersError = checkSameLineOnInactiveTiers(
    key,
    index,
    innerIndex,
    clonedTires,
    value,
    inactiveLinesOnSameTierError,
  );
  return new Set([...sameLineOnInactiveTiersError]);
};

const checkActiveLine = (key, index, innerIndex, tiers, value, tierErrors) => {
  let updatedTireErrors = [...tierErrors];
  if (value !== null && key === 'voluntary') {
    if (Number(tiers[index].data[innerIndex].involuntary) > Number(value)) {
      updatedTireErrors = new Set([
        ...updatedTireErrors,
        `tier-active-line-error-${index}-${innerIndex}-voluntary|Vehicles cannot be less than Involuntary`,
      ]);
    } else {
      updatedTireErrors = updatedTireErrors.filter(
        (error) => !new RegExp(`tier-active-line-error-${index}-${innerIndex}-voluntary`, 'ig').test(error),
      );
      updatedTireErrors = updatedTireErrors.filter(
        (error) => !new RegExp(`tier-active-line-error-${index}-${innerIndex}-involuntary`, 'ig').test(error),
      );
    }
  } else if (value !== null && key === 'involuntary') {
    if (Number(tiers[index].data[innerIndex].voluntary) < Number(value)) {
      updatedTireErrors = new Set([
        ...updatedTireErrors,
        `tier-active-line-error-${index}-${innerIndex}-involuntary|The number in this field cannot be greater than the previous field. Please change the number to an equal or lesser value.`,
      ]);
    } else {
      updatedTireErrors = updatedTireErrors.filter(
        (error) => !new RegExp(`tier-active-line-error-${index}-${innerIndex}-voluntary`, 'ig').test(error),
      );
      updatedTireErrors = updatedTireErrors.filter(
        (error) => !new RegExp(`tier-active-line-error-${index}-${innerIndex}-involuntary`, 'ig').test(error),
      );
    }
  }
  return updatedTireErrors;
};

// eslint-disable-next-line complexity
const checkInActiveLinesOnSameTier = (key, index, innerIndex, tiers, value, tierErrors) => {
  if (innerIndex === tiers[index].data.length - 1) {
    return [...tierErrors];
  }

  let updatedTireErrors = [...tierErrors].filter(
    (error) =>
      !new RegExp(`tier-inactive-prev-line-on-same-tier-error-${index}-${innerIndex}-${key}`, 'ig').test(error) &&
      !new RegExp(`tier-inactive-next-line-on-same-tier-error-${index}-${innerIndex}-${key}`, 'ig').test(error),
  );
  let isError = false;
  let error = '';
  for (let i = 0; i < tiers[index].data.length; i++) {
    if (i === innerIndex) continue;
    const tireValue = tiers[index].data[i];
    if (
      tireValue?.[key] !== null &&
      value !== null &&
      i < innerIndex &&
      Number(tireValue?.[key] || 0) > Number(value) &&
      key === 'voluntary'
    ) {
      isError = true;
      error = `tier-inactive-prev-line-on-same-tier-error-${index}-${innerIndex}-${key}|${
        key === 'involuntary' ? 'Involuntary' : 'Vehicles'
      } cannot be less than ${key === 'involuntary' ? 'Involuntary' : 'Vehicles'} of the previous line`;
    }
    if (
      tireValue?.[key] !== null &&
      value !== null &&
      i > innerIndex &&
      Number(tireValue?.[key] || 0) < Number(value) &&
      key === 'voluntary'
    ) {
      isError = true;
      error = `tier-inactive-next-line-on-same-tier-error-${index}-${innerIndex}-${key}|The number in this field cannot be greater than the previous field. Please change the number to an equal or lesser value.`;
    }
  }
  if (isError) {
    updatedTireErrors = new Set([...updatedTireErrors, error]);
  }

  return updatedTireErrors;
};

const checkSameLineOnInactiveTiers = (key, index, innerIndex, tiers, value, tierErrors) => {
  let updatedTireErrors = [...tierErrors].filter(
    (error) =>
      !new RegExp(`tier-same-line-on-prev-tier-error-${index}-${innerIndex}-voluntary`, 'ig').test(error) &&
      !new RegExp(`tier-same-line-on-next-tier-error-${index}-${innerIndex}-voluntary`, 'ig').test(error),
  );

  if (key === 'voluntary') {
    let isError = false;
    let error = '';
    for (let i = 0; i < tiers.length; i++) {
      if (i === index) continue;
      if (
        tiers[i].data[innerIndex].voluntary !== null &&
        value !== null &&
        i < index &&
        Number(tiers[i].data[innerIndex].voluntary) >= Number(value)
      ) {
        isError = true;
        error = `tier-same-line-on-prev-tier-error-${index}-${innerIndex}-voluntary|Vehicles cannot be same or less than Vehicles of the previous tier value. Please increase the value by at least 1.`;
        break;
      }
      if (
        tiers[i].data[innerIndex].voluntary !== null &&
        value !== null &&
        i > index &&
        Number(tiers[i].data[innerIndex].voluntary) <= Number(value)
      ) {
        isError = true;
        error = `tier-same-line-on-next-tier-error-${index}-${innerIndex}-voluntary|Vehicles cannot be same or greater than Vehicles of the next tier`;
        break;
      }
    }
    if (isError) {
      updatedTireErrors = new Set([...updatedTireErrors, error]);
    }
  }

  return updatedTireErrors;
};
